import script from "./Tier+TierButtons+ResearchNeeded+RemoveFromCampaignCell.vue?vue&type=script&setup=true&lang=js"
export * from "./Tier+TierButtons+ResearchNeeded+RemoveFromCampaignCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__